import LoginPageLogo from "../../assets/img/login-page-logo-dark.svg";
import { Link } from "react-router-dom";

const Timeout = () => {
  return (
    <>
      <section className="sign-in-page">
        <div className="container p-0">
          <div className="logo-container">
            <div>
              <img src={LoginPageLogo} alt="" className="login-from-logo" />
            </div>
            <div>
              <h3 className="font-weight-bold text-white">Cloud Defense</h3>
            </div>
          </div>

          <div className="row no-gutters">
            <div className="col-sm-12 align-self-center">
              <div className="sign-in-from">
                <h3 className="text-center text-danger mb-5">
                  Session timeout <br />
                  Please
                  <Link to="/">
                    <u>
                      <b>login</b>
                    </u>
                  </Link>{" "}
                  again to access the demo.
                </h3>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Timeout;
